import styled from 'styled-components';
import {useBreakpoints} from '@/hooks';
import {CHANNEL_TALK, NOTICE, POLICY_LINKS} from '@/router';
import {interceptProps} from '@/styled-components';
import {palette} from '@/styles';
import {typographyStyle} from '../Typography';
import Logo from './logo-gray.svg';

interface IProps {
  columnLayout?: boolean;
  hideCompanyInfo?: boolean;
}

export const Footer = ({columnLayout, hideCompanyInfo}: IProps) => {
  const {isMobile} = useBreakpoints();

  return (
    <Root>
      <img src={Logo} alt="로고" />
      <MenuSection columnLayout={columnLayout || isMobile}>
        <Menu>
          <SectionTitle>서비스 이용약관</SectionTitle>
          <a href={POLICY_LINKS.policy} target="blank">
            <MenuItem>이용약관</MenuItem>
          </a>
          <a href={POLICY_LINKS.paid} target="blank">
            <MenuItem>유료 서비스 이용약관</MenuItem>
          </a>
          <a href={POLICY_LINKS.private} target="blank">
            <MenuItem>개인정보 처리방침</MenuItem>
          </a>
        </Menu>
        <Menu>
          <SectionTitle>고객센터</SectionTitle>
          <a href={NOTICE} target="blank">
            <MenuItem>공지사항</MenuItem>
          </a>
          <a href={CHANNEL_TALK} target="blank">
            <MenuItem>1:1 문의</MenuItem>
          </a>
          <a href="mailto:contact@myfranchise.kr">
            <MenuItem>이메일 contact@myfranchise.kr</MenuItem>
          </a>
        </Menu>
      </MenuSection>
      {!hideCompanyInfo && (
        <Menu>
          <MenuItem>(주)마이프랜차이즈</MenuItem>
          <MoreText>
            대표이사: 김준용 | 사업자등록번호: 584-87-01610
            <br />
            통신판매신고: 제2021-서울강남-02597호
            <br />
            서울 강남구 테헤란로2길 27, 10층 1004호
          </MoreText>
        </Menu>
      )}
    </Root>
  );
};

const Root = styled.div`
  background-color: ${palette.gray100};
  padding: 24px 16px 54px;
`;

const MenuSection = styled('div').withConfig({
  shouldForwardProp: interceptProps(['columnLayout']),
})<{
  columnLayout?: boolean;
}>`
  margin-top: 24px;
  display: flex;
  gap: 40px;
  margin-bottom: 60px;
  ${({columnLayout}) =>
    columnLayout &&
    `
  flex-direction: column;
    gap: 58px;
  `}
`;

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SectionTitle = styled.div`
  ${{...typographyStyle.medium12}}
  color: ${palette.gray300};
`;

const MenuItem = styled.div`
  ${{...typographyStyle.bold12}}
  color: ${palette.gray400};
`;

const MoreText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: ${palette.gray400};
`;
